import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { Mgt1Service } from 'src/app/services/mgt1.service';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
import { Sh2Service } from 'src/app/services/sh2.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-sh2',
  templateUrl: './sh2.component.html',
  styleUrls: ['./sh2.component.css']
})
export class Sh2Component implements OnInit {

  sh2Form: FormGroup;
  sh2List : any = [];
  restrictTabflag: boolean;
  editParticularId: any;
  editParticularData: any;
  doaIssueofRenewedDuplicateShareCertiModel: { month: number; day: number; year: number; };
  doiRenewedDuplicateShareCertiModel: { month: number; day: number; year: number; };
  doiOGshareCerti: { month: number; day: number; year: number; };
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  certificateNoList: any[];
  registerList: any[];
  distinctiveFromList: any[];
  distinctiveToList: any[];
  folioNoDematAcNoList: any[];
  classofSharesList: any[];
  dateOfIssueList: any[];
  noOfSharesAllotedList: any[];
  nameOfMemberList: any[];
  sh2FormDetails:any[];
  Mgt1List:any[];
  directorData: any[];
  Sh2data: any[];
  disabledOnClick: boolean;
  pipe:any;

   constructor(private Sh2Service: Sh2Service,
    private activatedRoute: ActivatedRoute,
    private commonFunction: CommonFunction,
    private alert: AlertComponent,
    private router: Router,
    private mgt1Service: Mgt1Service) { }
  ngOnInit() {

    this.sh2Form = new FormGroup({
      
      ogShareCertiNumber: new FormControl('', [Validators.required,Validators.pattern("^[a-zA-Z0-9*-]*$"), Validators.maxLength(20)]),
      namePersonRenewedDuplicateCertiisIssued : new FormControl('',[]),
      doaIssueofRenewedDuplicateShareCerti : new FormControl('',[]),
      classofShares : new FormControl('',[]),
      totalSharesinOGshareCerti : new FormControl('',[]),
      folioNo : new FormControl('',[Validators.pattern("^[0-9]*$")]),
      doiOGshareCerti : new FormControl('',[]),
      disctinctiveNoofSharesFrom : new FormControl('',[]),
      disctinctiveNoofSharesTo : new FormControl('',[]),
      doiRenewedDuplicateShareCerti : new FormControl('',[]),
      reasonForIssueRenewedDuplicateShareCerti : new FormControl('',[Validators.pattern("^[a-zA-Z0-9 .,&'*\n-]*$"), Validators.maxLength(250)]),
      numberRenewedShareCertiifApplicable : new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(50)]),
      totalNoSharesRenewedDupliateShareCerti : new FormControl('',[Validators.pattern("^[0-9]*$"), Validators.maxLength(20)]),
      whetherRenewedDuplicateShareCertiisIssued : new FormControl('',[]),
      referenceEntryRegiterofMembers : new FormControl('',[Validators.pattern("^[a-zA-Z0-9 ,.'&-]*$"), Validators.maxLength(250)]) 
      
    });
    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.restrictTabflag = true;
        this.editParticularId = params['particularId'];
        this.getSh2ById(this.editParticularId);
      } else {
        this.restrictTabflag = false;
      }
    })
    this.getRegisterMgt1List();
      
  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['sh2list']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  getRegisterMgt1List() {
    this.certificateNoList = [];
    this.distinctiveFromList =[];
    this.distinctiveToList =[];
    this.folioNoDematAcNoList =[];
    this.classofSharesList =[];
    this.dateOfIssueList =[];
    this.noOfSharesAllotedList =[];
    this.nameOfMemberList =[];
    this.Mgt1List = [];

    this.mgt1Service.getMgtList({ search: false }).subscribe(MgtList => {
      this.Mgt1List.push(MgtList.data);
      for(let i=0; i< MgtList.data.length; i++){
        if(MgtList.data[i].personalDetails.nameOfMember){
        this.nameOfMemberList.push(MgtList.data[i].personalDetails.nameOfMember);
        }
        for(let j=0; j< MgtList.data[i].detailsOfHoldings.length; j++){
          this.certificateNoList.push({MGT1_id:MgtList.data[i].detailsOfHoldings[j]._id,
                                       certificateNo: MgtList.data[i].detailsOfHoldings[j].certificateNo});
          
         
          // if(MgtList.data[i].detailsOfHoldings[j].noOfSharesAlloted != ""){
          // this.noOfSharesAllotedList.push(MgtList.data[i].detailsOfHoldings[j].noOfSharesAlloted);
          // }
          // if(MgtList.data[i].detailsOfHoldings[j].distinctiveFrom != ""){
          //   this.distinctiveFromList.push(MgtList.data[i].detailsOfHoldings[j].distinctiveFrom);
          // }
          // if(MgtList.data[i].detailsOfHoldings[j]. distinctiveTo !="")
          // {
          //   this.distinctiveToList.push(MgtList.data[i].detailsOfHoldings[j]. distinctiveTo);
          // }
          // if(MgtList.data[i].detailsOfHoldings[j].dateOfIssue != null)
          // {
          // this.dateOfIssueList.push(MgtList.data[i].detailsOfHoldings[j].dateOfIssue);
          // }
        }
    }
      this.folioNoDematAcNoList = MgtList.data;
      this.classofSharesList = MgtList.data;
     
     
    });
  }


  getsh2FormDetails(ev,value){
     //var id = ev.target.value;

     const selectEl = ev.target;

    const MGT1_id = selectEl.options[selectEl.selectedIndex].getAttribute('data-mgt1id');

    // console.log('%%%%%%%%%%%%%%',MGT1_id)
    
    this.Sh2data = this.Mgt1List[0]
    this.sh2Form.controls.mgt1Id = MGT1_id;
    for(let i=0; i< this.Sh2data.length; i++){
      
      console.log("***********************************element",this.Sh2data[i]);
  
      this.Sh2data[i].detailsOfHoldings.forEach(item => {
          if(item.certificateNo == value){
            // console.log("************************match************",item.certificateNo == value)
            this.sh2Form.controls.namePersonRenewedDuplicateCertiisIssued.setValue(this.Sh2data[i].personalDetails.nameOfMember);
            this.sh2Form.controls.classofShares.setValue(this.Sh2data[i].selectTypes);
            this.sh2Form.controls.totalSharesinOGshareCerti.setValue(item.noOfSharesAlloted);
            this.sh2Form.controls.folioNo.setValue(this.Sh2data[i].folioNoDematAcNo);
            console.log("item.dateOfIssue",item.dateOfIssue);
          
            if (item.dateOfIssue != null) {
              let dt = new Date(this.setFormatDate(item.dateOfIssue));
              this.doiOGshareCerti = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
           
            this.sh2Form.controls.disctinctiveNoofSharesFrom.setValue(item.distinctiveFrom);
            this.sh2Form.controls.disctinctiveNoofSharesTo.setValue(item.distinctiveTo);
           
          }
        })
    }
    // this.Mgt1List.forEach(element => {
    //   console.log("***********************************element",element);
  
    //   element.detailsOfHoldings.forEach(item => {
    //     if(item.certificateNo == value){
    //       console.log("************************match************",item.certificateNo == value)
    //       this.sh2Form.controls.namePersonRenewedDuplicateCertiisIssued.setValue(element.personalDetails.nameOfMember);
    //     }
    //   })
    // });
  } 

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  } 
  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }
  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  showFormEntry() {
    this.disabledOnClick = true;
    var object = {
      ogShareCertiNumber: this.sh2Form.controls.ogShareCertiNumber.value,
      namePersonRenewedDuplicateCertiisIssued: this.sh2Form.controls.namePersonRenewedDuplicateCertiisIssued.value,
      doaIssueofRenewedDuplicateShareCerti: this.setDate(this.sh2Form.controls.doaIssueofRenewedDuplicateShareCerti.value),
      classofShares: this.sh2Form.controls.classofShares.value,
      totalSharesinOGshareCerti: this.sh2Form.controls.totalSharesinOGshareCerti.value,
      folioNo: this.sh2Form.controls.folioNo.value,
      doiOGshareCerti:  this.setDate(this.sh2Form.controls.doiOGshareCerti.value),
      disctinctiveNoofSharesFrom: this.sh2Form.controls.disctinctiveNoofSharesFrom.value,
      disctinctiveNoofSharesTo: this.sh2Form.controls.disctinctiveNoofSharesTo.value,
      doiRenewedDuplicateShareCerti: this.setDate(this.sh2Form.controls.doiRenewedDuplicateShareCerti.value),
      reasonForIssueRenewedDuplicateShareCerti: this.sh2Form.controls.reasonForIssueRenewedDuplicateShareCerti.value,
      numberRenewedShareCertiifApplicable: this.sh2Form.controls.numberRenewedShareCertiifApplicable.value,
      totalNoSharesRenewedDupliateShareCerti: this.sh2Form.controls.totalNoSharesRenewedDupliateShareCerti.value,
      whetherRenewedDuplicateShareCertiisIssued: this.sh2Form.controls.whetherRenewedDuplicateShareCertiisIssued.value,
      referenceEntryRegiterofMembers: this.sh2Form.controls.referenceEntryRegiterofMembers.value,
      mgt1Id:this.sh2Form.controls.mgt1Id

    }

    this.Sh2Service.sampleShRecord(object).subscribe(response => {
      this.disabledOnClick = false;
      if (response.status == 0) {
        this.restrictTabflag = true;
        this.alert.successWithOk(response.message, 'sh2list');
      } else {
        this.restrictTabflag = false;
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
        
      }
    })
    
  }

  dateSet(date) {
  
    if (date != "" && date != null) {
      if(date.month != undefined && date.day != undefined && date.year != undefined){
        return date.month + "-" + date.day + "-" + date.year;
      }
         else return date;   
    }
    return null;
    }
    
  getSh2ById(particularId) {
    this.Sh2Service.updatesh2(particularId).subscribe(response => {
      
      this.editParticularData = response.data[0];
      this.sh2Form.controls.mgt1Id =this.editParticularData.mgt1Id

      this.mgt1Service.getMgtList({ search: false }).subscribe(MgtList => {
        // this.Mgt1List.push(MgtList.data);
        MgtList.data.forEach(element => {
          element.detailsOfHoldings.forEach(item => {
            if(item._id == this.editParticularData.mgt1Id){
              this.sh2Form.controls.ogShareCertiNumber.setValue(item.certificateNo);
              this.sh2Form.controls.totalSharesinOGshareCerti.setValue(item.noOfSharesAlloted);
              this.sh2Form.controls.disctinctiveNoofSharesFrom.setValue(item.distinctiveFrom);
              this.sh2Form.controls.disctinctiveNoofSharesTo.setValue(item.distinctiveTo);
              this.sh2Form.controls.folioNo.setValue(element.folioNoDematAcNo);
              this.sh2Form.controls.classofShares.setValue(element.selectTypes);
              this.sh2Form.controls.namePersonRenewedDuplicateCertiisIssued.setValue(element.personalDetails.nameOfMember);
              return false
            }
          })
        })
      });

      // this.sh2Form.controls.ogShareCertiNumber.setValue(this.editParticularData.ogShareCertiNumber);
      // this.sh2Form.controls.namePersonRenewedDuplicateCertiisIssued.setValue(this.editParticularData.namePersonRenewedDuplicateCertiisIssued);
      this.sh2Form.controls.doaIssueofRenewedDuplicateShareCerti.setValue(this.editParticularData.doaIssueofRenewedDuplicateShareCerti);
      // this.sh2Form.controls.classofShares.setValue(this.editParticularData.classofShares);
      this.sh2Form.controls.totalSharesinOGshareCerti.setValue(this.editParticularData.totalSharesinOGshareCerti);
      // this.sh2Form.controls.folioNo.setValue(this.editParticularData.folioNo);
      // this.sh2Form.controls.doiOGshareCerti.setValue(this.editParticularData.doiOGshareCerti);
      // this.sh2Form.controls.disctinctiveNoofSharesFrom.setValue(this.editParticularData.disctinctiveNoofSharesFrom);
      // this.sh2Form.controls.disctinctiveNoofSharesTo.setValue(this.editParticularData.disctinctiveNoofSharesTo);
      this.sh2Form.controls.doiRenewedDuplicateShareCerti.setValue(this.editParticularData.doiRenewedDuplicateShareCerti);
      this.sh2Form.controls.reasonForIssueRenewedDuplicateShareCerti.setValue(this.editParticularData.reasonForIssueRenewedDuplicateShareCerti);
      this.sh2Form.controls.numberRenewedShareCertiifApplicable.setValue(this.editParticularData.numberRenewedShareCertiifApplicable);
      this.sh2Form.controls.totalNoSharesRenewedDupliateShareCerti.setValue(this.editParticularData.totalNoSharesRenewedDupliateShareCerti);
      this.sh2Form.controls.whetherRenewedDuplicateShareCertiisIssued.setValue(this.editParticularData.whetherRenewedDuplicateShareCertiisIssued);
      this.sh2Form.controls.referenceEntryRegiterofMembers.setValue(this.editParticularData.referenceEntryRegiterofMembers);
      

      if (this.editParticularData.doaIssueofRenewedDuplicateShareCerti != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.doaIssueofRenewedDuplicateShareCerti));
        this.doaIssueofRenewedDuplicateShareCertiModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.doiRenewedDuplicateShareCerti != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.doiRenewedDuplicateShareCerti));
        this.doiRenewedDuplicateShareCertiModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.doiOGshareCerti != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.doiOGshareCerti));
        this.doiOGshareCerti = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
    });
  }


  updateSh2() {
    this.disabledOnClick = true;
   var object = {
   ogShareCertiNumber: this.sh2Form.controls.ogShareCertiNumber.value,
   namePersonRenewedDuplicateCertiisIssued: this.sh2Form.controls.namePersonRenewedDuplicateCertiisIssued.value,
   doaIssueofRenewedDuplicateShareCerti: this.setDate(this.doaIssueofRenewedDuplicateShareCertiModel),
   classofShares: this.sh2Form.controls.classofShares.value,
   totalSharesinOGshareCerti: this.sh2Form.controls.totalSharesinOGshareCerti.value,
   folioNo: this.sh2Form.controls.folioNo.value,
   doiOGshareCerti: this.dateSet(this.sh2Form.controls.doiOGshareCerti.value),
   disctinctiveNoofSharesFrom: this.sh2Form.controls.disctinctiveNoofSharesFrom.value,
   disctinctiveNoofSharesTo: this.sh2Form.controls.disctinctiveNoofSharesTo.value,
   doiRenewedDuplicateShareCerti: this.setDate(this.doiRenewedDuplicateShareCertiModel),
   reasonForIssueRenewedDuplicateShareCerti: this.sh2Form.controls.reasonForIssueRenewedDuplicateShareCerti.value,
   numberRenewedShareCertiifApplicable: this.sh2Form.controls.numberRenewedShareCertiifApplicable.value,
   totalNoSharesRenewedDupliateShareCerti: this.sh2Form.controls.totalNoSharesRenewedDupliateShareCerti.value,
   whetherRenewedDuplicateShareCertiisIssued: this.sh2Form.controls.whetherRenewedDuplicateShareCertiisIssued.value,
   referenceEntryRegiterofMembers: this.sh2Form.controls.referenceEntryRegiterofMembers.value,
   mgt1Id:this.sh2Form.controls.mgt1Id


    }
    this.Sh2Service.updateSh2(object, this.editParticularId).subscribe(response => {
      this.disabledOnClick = false;
      if (response.status == 0) {
        this.alert.successWithOk(response.message,'sh2list');
      } 
      else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }

    });
  }

  generateOutput() {
    var object = {
      id: this.editParticularId,
      fromDate: null,
      toDate: null
    }
    this.Sh2Service.generateSh2Document(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editParticularId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editParticularId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.Sh2Service.downloadSh2File(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.Sh2Service.downloadSh2PdfFile(id, 'Single');
  }

}





